export default __webpack_public_path__ + "static/media/Newday_LOA.0e432116.pdf";